module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_7005.0bb58604.png";